import React from 'react'
import "./Graph.css"

export const Graph = () => {
  var jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec;

  if (localStorage.getItem("$TEXPENSES")==0){
    jan = 0;
    feb = 0;
    mar = 0;
    apr = 0;
    may = 0;
    jun = 0;
    jul = 0;
    aug = 0;
    sep = 0;
    oct = 0;
    nov = 0;
    dec = 0;
  }
  else{
    jan = ((localStorage.getItem("$EJAN")/localStorage.getItem("$TEXPENSES"))*450)
    feb = ((localStorage.getItem("$EFEB")/localStorage.getItem("$TEXPENSES"))*450)
    mar = ((localStorage.getItem("$EMAR")/localStorage.getItem("$TEXPENSES"))*450)
    apr = ((localStorage.getItem("$EAPR")/localStorage.getItem("$TEXPENSES"))*450)
    may = ((localStorage.getItem("$EMAY")/localStorage.getItem("$TEXPENSES"))*450)
    jun = ((localStorage.getItem("$EJUN")/localStorage.getItem("$TEXPENSES"))*450)
    jul = ((localStorage.getItem("$EJUL")/localStorage.getItem("$TEXPENSES"))*450)
    aug = ((localStorage.getItem("$EAUG")/localStorage.getItem("$TEXPENSES"))*450)
    sep = ((localStorage.getItem("$ESEP")/localStorage.getItem("$TEXPENSES"))*450)
    oct = ((localStorage.getItem("$EOCT")/localStorage.getItem("$TEXPENSES"))*450)
    nov = ((localStorage.getItem("$ENOV")/localStorage.getItem("$TEXPENSES"))*450)
    dec = ((localStorage.getItem("$EDEC")/localStorage.getItem("$TEXPENSES"))*450)
  }

  return (
    <div id="graph-sec">
        <h1 style={{color: "white", fontSize: "40px", textAlign: "center", paddingTop: "80px"}}>Data Graph</h1><br/><br/><br/><br/>
        <center>
            <div id="graph-container">
                <hr id="red-mark"></hr>
                  <div id="jan" className='bar' style={{height: jan, backgroundColor: ((localStorage.getItem("$EJAN")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="feb" className='bar' style={{height: feb, backgroundColor: ((localStorage.getItem("$EFEB")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="mar" className='bar' style={{height: mar, backgroundColor: ((localStorage.getItem("$EMAR")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="apr" className='bar' style={{height: apr, backgroundColor: ((localStorage.getItem("$EAPR")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="may" className='bar' style={{height: may, backgroundColor: ((localStorage.getItem("$EMAY")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="jun" className='bar' style={{height: jun, backgroundColor: ((localStorage.getItem("$EJUN")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="jul" className='bar' style={{height: jul, backgroundColor: ((localStorage.getItem("$EJUL")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="aug" className='bar' style={{height: aug, backgroundColor: ((localStorage.getItem("$EAUG")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="sep" className='bar' style={{height: sep, backgroundColor: ((localStorage.getItem("$ESEP")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="oct" className='bar' style={{height: oct, backgroundColor: ((localStorage.getItem("$EOCT")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="nov" className='bar' style={{height: nov, backgroundColor: ((localStorage.getItem("$ENOV")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
                  <div id="dec" className='bar' style={{height: dec, backgroundColor: ((localStorage.getItem("$EDEC")/localStorage.getItem("$TEXPENSES"))*100)>=80?"rgb(255, 0, 0)":"rgb(42, 124, 201)"}}></div>
            </div>
        </center>
    </div>
  )
}
